import React from 'react';
import './ArticleMedia.css'
import { lazyLoad } from '../../helpers/imageLoader.lazy';
class ArticleMedia extends React.Component {
    state = {
        media: [],
        editMode: false,
        headerImage: ""
    }
    componentDidMount() {
        document.addEventListener("scroll", lazyLoad);
    }
    componentDidUpdate(prevProps) {
        if (this.props.media !== undefined && prevProps.media !== this.props.media) {
            this.setState({ media: this.props.media }, () => {
                lazyLoad();
            });
        }
        if (this.props.headerImage !== undefined && prevProps.headerImage !== this.props.headerImage) {
            this.setState({ headerImage: this.props.headerImage });
        }
        if (this.props.editMode !== undefined && prevProps.editMode !== this.props.editMode) {
            this.setState({ editMode: this.props.editMode });
        }
    }
    render() {
        const { media, editMode, headerImage } = this.state;
        const { onDelete } = this.props;
        return (
            <div className="media-container">
                {media.length > 0 && media.filter(m => { return m.url !== headerImage }).map((v, i) => {
                    if (v.url !== undefined) {
                        return v.type.includes('image/') ?
                            <div className={editMode ? 'article-media' : 'feed'}>
                                {!editMode ? <img data-src={v.url}
                                    data-srcset={v.url}
                                    className="lazy blur"
                                    src="https://images.iphonephotographyschool.com/22686/1120b/How-To-Blur-Background-On-iPhone.jpg" /> :
                                    <img
                                        src={v.url} />}
                                {editMode && <i className="fa fa-trash delete-media" onClick={() => onDelete(v.name)} />}
                            </div> :
                            <div className={editMode ? 'article-media' : 'feed'}>
                                <video controls autoPlay >
                                    <source src={v.url} type="video/mp4" />
                                    <source src={v.url} type="video/quicktime" />
                                    <source src={v.url} type="video/MOV" />
                                </video>
                                {editMode && <i className="fa fa-trash delete-media" onClick={() => onDelete(v.name)} />}
                            </div>
                    }
                    return <div className={v.type.includes('image/') ? 'file-upload-bar video-bar' : 'file-upload-bar image-bar'} key={i}>
                        <i className={v.type.includes('image/') ?
                            'fa fa-file-image-o' :
                            'fa fa-file-movie-o'} />
                        {v.name}
                    </div>
                })}
            </div>
        )
    }
}


export default ArticleMedia;
